import type { HomeVideoDto } from "../../shared/dto";
import { VideoGate, VideoPreparingCard } from "../VideoGate";

// F81 (Pavel 2026-08-06, call decision 5.8.): the group calls are gone. The
// "Úvodní hovor" and "Marketingový hovor" steps are VIDEO steps now - the
// client watches the video and the next step opens at the video's unlock
// moment. No enrollment, no dates, no zoom links on these steps; booking a
// call with the partner lives on in the side rail (PartnerControl), which
// this change does not touch. One module still owns the whole step
// experience, so the overview and the rail surface render the SAME thing
// (the F35 law survives the content swap).
export type VideoStepKey = "onboarding_call" | "marketing_call";

// Per-step copy keys. The step differs only in its sentences, never in its
// shape (both videos look and behave the same).
const VIDEO_COPY_KEYS: Record<VideoStepKey, string> = {
  onboarding_call: "homeSteps.call.videoCopy",
  marketing_call: "sections.marketing_call.videoActionCopy"
};

/**
 * The numbered video step as the overview renders it: icon + step name, one
 * human sentence, the gated player (or the honest "video is being prepared"
 * card), and the note naming what the video unlocks. The rail step surface
 * renders this exact element, so there is one step experience.
 */
export function VideoStepPanel(props: {
  stepKey: VideoStepKey;
  number: number;
  csrfToken: string;
  t: (key: string) => string;
  video: HomeVideoDto | null;
  onContinue: () => void | Promise<void>;
}) {
  const { stepKey, t } = props;
  return (
    <li
      className="home-step"
      data-call-step={stepKey}
      {...(stepKey === "onboarding_call" ? { "data-onboarding-call": "open" } : {})}
    >
      <span className="home-step-num step-number-token" aria-hidden="true">{props.number}</span>
      <div className="home-step-body">
        <div className="home-step-title">
          <svg className="home-step-icon" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M17 10.5V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4Z"/></svg>
          <strong>{t(`rail.steps.${stepKey}`)}</strong>
        </div>
        <p>{t(VIDEO_COPY_KEYS[stepKey])}</p>
        {props.video ? (
          <VideoGate videoKey={props.video.key} csrfToken={props.csrfToken} t={t} onContinue={props.onContinue} />
        ) : (
          <VideoPreparingCard t={t} />
        )}
        <p>{t(`sections.${stepKey}.unlocksNote`)}</p>
      </div>
    </li>
  );
}
